export default __webpack_public_path__ + "static/media/menu.d8a85ffd.svg";